import { FC, useCallback, useMemo } from "react";

import { EnumListSchemaItem, EnumOption } from "@data-root/types";
import { InputWithOptions } from ".";
import { inputGuard } from "../../hocs/guard";
import { SchemaItemProps, useField } from "@data-root/react";
import { View } from "@data-root/react";
import { Button, Space, Tooltip, Typography } from "antd";
import { Remarks } from "../remarks";

const { Title } = Typography;

export const EnumInputInlinePresentation: FC<SchemaItemProps<EnumListSchemaItem>> = ({ item }) => {
  const { loaded, displayName, editable, show, value, setValue: _setValue, remarks } = useField(item);

  const handleSetValue = useCallback(
    (option: EnumOption) => {
      if (!editable || !loaded) return;

      _setValue(option.id, option.name);
    },
    [_setValue, editable, loaded]
  );

  if (!show) return null;

  return (
    <View style={{ width: "100%" }}>
      <Title level={5}>{displayName}</Title>

      <Space wrap>
        {item.options.map((option) => (
          <Tooltip key={option.id} title={option.description ?? option.name}>
            <Button
              loading={!loaded}
              key={option.id}
              onClick={() => handleSetValue(option)}
              type={(value as string[]).includes(option.id) ? "primary" : "default"}
            >
              {option.name}
            </Button>
          </Tooltip>
        ))}
      </Space>

      <Remarks texts={remarks} />
    </View>
  );
};

export const EnumListInput: FC<SchemaItemProps<EnumListSchemaItem>> = inputGuard(({ item }) => {
  const options = useMemo(() => item.options, [item.options]);

  return <InputWithOptions multiple item={item} options={options} />;
});
